import { jsx as _jsx } from "react/jsx-runtime";
import { titlePlaceholder } from "../../../helpers/placeholders";
const DraggableTitle = ({ item: { props, id }, ...rest }) => {
    const Component = props?.component || "h1";
    return (_jsx(Component, { className: props?.className ||
            "font-heading text-4xl font-bold text-gray-900 sm:tracking-tight", "editor-key": id, ...rest, children: props?.text || titlePlaceholder.value }));
};
export default DraggableTitle;
//# sourceMappingURL=DraggableTitle.js.map